export default "__VITE_ASSET__D5jcsoK7__"